export default __webpack_public_path__ + "static/media/WheelsWatch.a5c54b5ed0af390544e39e55e911ccfb.webp";